import { RequestDetail } from "./Request";

export enum TemplateType {
  PRESCRIPTION = "PRESCRIPTION",
  COMPOUNDED_PRESCRIPTION = "COMPOUNDED_PRESCRIPTION",
  MEDICAL_CERTIFICATE = "MEDICAL_CERTIFICATE",
  MEDICAL_ORDER = "MEDICAL_ORDER",
}

export interface Template {
  id: string;
  name: string;
  templateType: TemplateType;
  createdAt: number;
  updatedAt: number;
  prescriptionDetails?: PrescriptionTemplateDetail[];
}

export type PrescriptionTemplateDetail = Omit<
  RequestDetail,
  "id" | "requestId"
>;
